import React from 'react';
import { Link } from 'react-router-dom';
import { companyProfile, contactServices, navigationLinks } from '../content/siteContent';

function AdmissionFooter() {
  return (
    <footer className="ca-footer">
      <div className="ca-container ca-footer__grid">
        <div>
          <h3>{companyProfile.brandName}</h3>
          <p>{companyProfile.tagline}</p>
          <p>{companyProfile.registeredAddress}</p>
        </div>

        <div>
          <h4>Quick Links</h4>
          <ul>
            {navigationLinks.map((item) => (
              <li key={item.to}>
                <Link to={item.to}>{item.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4>Admission Support</h4>
          <ul>
            {contactServices.slice(0, 5).map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>

        <div>
          <h4>Contact</h4>
          <ul>
            <li>
              <a href={`tel:${companyProfile.phone.replace(/\s+/g, '')}`}>{companyProfile.phone}</a>
            </li>
            <li>
              <a href={`mailto:${companyProfile.primaryEmail}`}>{companyProfile.primaryEmail}</a>
            </li>
            <li>
              <a href="https://wa.me/918758637022" target="_blank" rel="noreferrer">
                WhatsApp Support
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="ca-footer__bottom">
        <div className="ca-container">
          <p>Copyright {new Date().getFullYear()} Vedanskrix Web LLP. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default AdmissionFooter;
